const PetitionError = require('../../petitionError');
const { post } = require('../../httpRequester');

class CreateThirdPartyTokenException extends PetitionError {
  static maxTokens = 'Max_tokens';

  constructor(code) {
    super('Create User', code);
  }
}

async function saveThirdPartyToken(payload, token) {
  const response = await post('users/third_party_token', payload, token);

  if (response.result !== CreateThirdPartyTokenException.success) {
    throw new CreateThirdPartyTokenException(response.result);
  } else {
    return response.user; // TODO transform
  }
}

module.exports = { saveThirdPartyToken, CreateThirdPartyTokenException };
